// extracted by mini-css-extract-plugin
export default {"main":"layout-module--main--3f0fd","hasSpace":"layout-module--hasSpace--64c4c","fadeIn":"layout-module--fadeIn--778d7"};